import React from 'react';
import * as allConstants from '../../../../../constants/allConstants';
import {Box} from '@mui/material';
import {fieldBank} from '../fieldBank';
import mechanicalUtils from '../mechUtils';
import * as Yup from 'yup';
import SystemFormWrapper from './systemFormWrapper';

const HpuSystem = (props)=> {
  // const [selected, setSelected] = useState();
  const MECH_FIELDS = allConstants.JOB_FIELDS.MECHANICAL;
  const SHARED = allConstants.JOB_FIELDS.SHARED;
  const EQUIPMENT = allConstants.EQUIPMENT;
  const system = allConstants.JOB_FIELDS.MECHANICAL.HPU_SYSTEM.api_name;
  const options = [EQUIPMENT.FURNACE, EQUIPMENT.AIR_HANDLER,  EQUIPMENT.HEAT_PUMP_PU, EQUIPMENT.GAS_PU];
  const filterTons =   {filterOptions: (opt)=> opt.value !== allConstants.TONS_OPTIONS.BASE['4.5'].value};

  const equipmentMap = {
    [EQUIPMENT.FURNACE.api_name]: {
      name: EQUIPMENT.FURNACE.api_name,
      fields: [
        fieldBank[MECH_FIELDS.BTUS.api_name],
        fieldBank[SHARED.ACTION.api_name],
        fieldBank[SHARED.CONVERT_FROM.api_name],
        fieldBank[SHARED.CONVERT_TO.api_name],
        {...fieldBank[SHARED.LOCATION.api_name], ...{options: allConstants.EQ_LOCATIONS.FURNANCE_LOCAIONS}},
        fieldBank[MECH_FIELDS.AFUE.api_name],
        fieldBank[MECH_FIELDS.MAKE.api_name],
        fieldBank[MECH_FIELDS.MODEL.api_name],
        fieldBank[MECH_FIELDS.NEED_GAS.api_name],
        fieldBank[MECH_FIELDS.NEED_ELECTRICAL.api_name]
      ]
    },
    [EQUIPMENT.GAS_PU.api_name]: {
      name: EQUIPMENT.GAS_PU.api_name,
      fields: [
        {...fieldBank[MECH_FIELDS.TONS.api_name], ...filterTons},
        fieldBank[SHARED.ACTION.api_name],
        fieldBank[SHARED.CONVERT_FROM.api_name],
        fieldBank[SHARED.CONVERT_TO.api_name],
        fieldBank[SHARED.LOCATION.api_name],
        fieldBank[MECH_FIELDS.SEER.api_name],
        fieldBank[MECH_FIELDS.MAKE.api_name],
        fieldBank[MECH_FIELDS.MODEL.api_name],
        fieldBank[MECH_FIELDS.SERIAL.api_name],
        fieldBank[MECH_FIELDS.NEED_ELECTRICAL.api_name],

      ]
    },
    [EQUIPMENT.HEAT_PUMP_PU.api_name]: {
      name: EQUIPMENT.HEAT_PUMP_PU.api_name,
      fields: [
        {...fieldBank[MECH_FIELDS.TONS.api_name], ...filterTons},
        fieldBank[SHARED.ACTION.api_name],
        fieldBank[SHARED.CONVERT_FROM.api_name],
        fieldBank[SHARED.CONVERT_TO.api_name],
        fieldBank[SHARED.LOCATION.api_name],
        fieldBank[MECH_FIELDS.SEER.api_name],
        fieldBank[MECH_FIELDS.MAKE.api_name],
        fieldBank[MECH_FIELDS.MODEL.api_name],
        fieldBank[MECH_FIELDS.SERIAL.api_name],
        fieldBank[MECH_FIELDS.NEED_ELECTRICAL.api_name],

      ]
    },
    [EQUIPMENT.AIR_HANDLER.api_name]: {
      name: EQUIPMENT.HEAT_PUMP_PU.api_name,
      fields: [
        fieldBank[MECH_FIELDS.BTUS.api_name],
        fieldBank[SHARED.ACTION.api_name],
        fieldBank[SHARED.CONVERT_FROM.api_name],
        fieldBank[SHARED.CONVERT_TO.api_name],
        {...fieldBank[SHARED.LOCATION.api_name], ...{options: allConstants.EQ_LOCATIONS.FURNANCE_LOCAIONS}},
        fieldBank[MECH_FIELDS.HSPF.api_name],
        fieldBank[MECH_FIELDS.MAKE.api_name],
        fieldBank[MECH_FIELDS.MODEL.api_name],
        fieldBank[MECH_FIELDS.NEED_ELECTRICAL.api_name],
      ]
    },
  };
  const validationSchema =Yup.object().shape({
    [EQUIPMENT.FURNACE.api_name]: Yup.array().of(Yup.object().shape({
      fields: (()=>{
        const {shape, edges} = mechanicalUtils.validateIfAnyInRowIsNotEmpty(
          [MECH_FIELDS.BTUS.api_name, SHARED.ACTION.api_name, SHARED.LOCATION.api_name, MECH_FIELDS.AFUE.api_name],
          equipmentMap[EQUIPMENT.FURNACE.api_name].fields);
        return Yup.array().of(Yup.object().shape(shape, edges));
      })(),
    })),
    [EQUIPMENT.HEAT_PUMP_PU.api_name]: Yup.array().of(Yup.object().shape({
      fields: (()=>{
        const {shape, edges} = mechanicalUtils.validateIfAnyInRowIsNotEmpty(
          [MECH_FIELDS.TONS.api_name, SHARED.ACTION.api_name, SHARED.LOCATION.api_name],
          equipmentMap[EQUIPMENT.HEAT_PUMP_PU.api_name].fields);
        return Yup.array().of(Yup.object().shape(shape, edges));
      })(),
    })),
    [EQUIPMENT.GAS_PU.api_name]: Yup.array().of(Yup.object().shape({
      fields: (()=>{
        const {shape, edges} = mechanicalUtils.validateIfAnyInRowIsNotEmpty(
          [MECH_FIELDS.TONS.api_name, SHARED.ACTION.api_name, SHARED.LOCATION.api_name],
          equipmentMap[EQUIPMENT.GAS_PU.api_name].fields);
        return Yup.array().of(Yup.object().shape(shape, edges));
      })(),
    })),
    [EQUIPMENT.AIR_HANDLER.api_name]: Yup.array().of(Yup.object().shape({
      fields: (()=>{
        const {shape, edges} = mechanicalUtils.validateIfAnyInRowIsNotEmpty(
          [MECH_FIELDS.BTUS.api_name, SHARED.ACTION.api_name, SHARED.LOCATION.api_name, MECH_FIELDS.HSPF.api_name],
          equipmentMap[EQUIPMENT.AIR_HANDLER.api_name].fields);
        return Yup.array().of(Yup.object().shape(shape, edges));
      })(),
    })),
  });
  return(
    <>
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
        {SystemFormWrapper({
          ...props,
          options: options,
          system: system,
          equipmentMap: equipmentMap,
          validationSchema: validationSchema,
          // setSelectedToParent: setSelected
        })}
      </Box>
    </>
  );
};
//
// HpuSystem.propTypes = {
//   saveSelectedEquipment: PropTypes.func,
//   getSelectedEquipment: PropTypes.func,
// };
//
// HpuSystem.defaultProps = {
//   saveSelectedEquipment: ()=>{},
//   getSelectedEquipment: ()=>{return [];},
// };
export default HpuSystem;
